import {Divider, Drawer, Stack} from "@mui/material"
import {useEffect, useRef, useState} from "react"
import SearchExpert from "../SearchExpert/SearchExpert"
import ExpertList from "../ExpertList/ExpertList"
import useExpertBioStore from "../../../stores/expertBioStore"
import {ExpertSearchFilter} from "../../molecules/ExpertSearchFilters"
import {expertListStore} from "../../../stores"

const FindExpert = () => {
  const [filters, setFilters] = useState({searchText: ""})
  const {showFindExpert, setShowFindExpert} = useExpertBioStore()
  const {expertList, searchExpertList} = expertListStore()
  const {searchTerm, regions, setSearchTerm, setRegion} = expertListStore()
  const expertListBoxRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    expertListBoxRef.current?.scrollTo(0, 0)
  }, [expertList, searchExpertList, searchTerm, regions, showFindExpert])

  let regionsBox = ""
  const handleCheckboxChange = (newState: {[key: string]: boolean}) => {
    regionsBox = Object.keys(newState)
      .filter((key) => (newState[key] ? key : null))
      .join(",")
    setRegion(regionsBox)
  }

  const handleSearchTextChange = (text: string) => {
    setSearchTerm(text)
  }

  return (
    <Drawer
      open={showFindExpert}
      disableEnforceFocus
      anchor="right"
      sx={{
        zIndex: 100,
        marginTop: "88px",
        marginBottom: "72px",
        height: "100dvh",
        backdropFilter: "blur(5px)",
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(126, 128, 129, 0.3)",
        },
        "& .MuiDrawer-paper": {
          width: "464px",
          backgroundColor: "white",
          backdropFilter: "blur(5px)",
          boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <Stack overflow="hidden">
        <SearchExpert
          setShowFindExpert={setShowFindExpert}
          filters={{filters, setFilters}}
          onSearchTextChange={handleSearchTextChange}
        />
        <ExpertSearchFilter onCheckboxChange={handleCheckboxChange} />
        <Divider />
        <Stack
          id="expertListBox"
          ref={expertListBoxRef}
          className="find-expert-scrollbars"
          sx={{
            height: "calc(100vh - 300px)",
            mr: 0.5,
            overflowY: "auto",
            overflowX: "hidden",
            paddingRight: "24px",
            paddingLeft: "24px",
            paddingTop: "24px",
            marginRight: "5px",
            // "&::-webkit-scrollbar": {},
            // "&::-webkit-scrollbar-track": {
            //   backgroundClip: "content-box",
            // },
          }}
        >
          <ExpertList parentRef={expertListBoxRef} />
        </Stack>
      </Stack>
    </Drawer>
  )
}

export default FindExpert
